export default __webpack_public_path__ + "static/icon-6-2-1a6a403b6ac0ba440a8def6ebbf5cc76.png";